import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/凯洛亚";
import { Soulmark } from "../../core/soulmark";
import { Effect, RoundEffect } from "../../core/effect";
import * as effect from "../../core/effect";
import * as cond from "../../core/cond";
import * as pred from "../../core/pred";
import { Timing } from "../../core/timing";

export class 凯洛亚 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(1131, "凯洛亚", type.水·超能, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark(
            [
                "1. 凯洛亚出场时开启<span style='color: #33c0ed; font-weight: bold;'>水之结界</span>：消除对手的能力提升状态，消除成功则2回合内对手无法使用攻击技能；然后不论如何，3回合内，对手无法处于能力提升状态，无法解除或反转自身的能力下降状态。",
                "2. 回合开始时，若对手不处于全属性能力下降状态，则令对手全属性-1；若对手处于能力下降状态，则100%令对手束缚。",
                "3. 回合结束时，若对手处于能力下降状态，则下1回合直接攻击必定致命一击；若对手不处于全属性能力下降状态，则吸取对手最大体力的1/3。",
            ],
            [
                new Effect(new effect.消除强化(), Timing.petOn, undefined, [
                    new RoundEffect(
                        Timing.triggered,
                        2,
                        new effect.免疫攻击(),
                    ),
                ]),
                new Effect(new effect.弱化(), Timing.roundBegin),
                new RoundEffect(
                    Timing.roundEnd,
                    1,
                    new effect.暴击(),
                    Timing.beforeDamage,
                    undefined,
                    false,
                    [],
                    cond.若对手处于弱化状态,
                ),
                new Effect(
                    new effect.吸取体力(pred.对手最大体力的x分之一(3)),
                    Timing.roundEnd,
                    cond.若对手不处于弱化状态,
                )
            ]
        );
        this.技能组 = [
            skill.破浪念闪,
            skill.蓝色水翼,
            skill.幻舞激流,
            skill.断流怒啸,
            skill.异光幻流,
        ];
    }
}
